import { useState } from "react";
import { faqData } from "@/mocks/homeData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">常见问答</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">解答您最关心的使用问题</p>
        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/50 overflow-hidden cursor-pointer"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <div className="flex items-center justify-between p-4 md:p-5">
                <h3 className="text-foreground-200 text-sm md:text-base font-medium pr-4 flex-1">{item.q}</h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500">
                  <i className={`text-sm transition-transform duration-300 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </span>
              </div>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96 pb-4 md:pb-5 px-4 md:px-5" : "max-h-0"
                }`}
              >
                <p className="text-foreground-500 text-sm leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}